import priceFormatter from './priceFormatter';

export const DEFAULT_CURRENCY = 'PLN';

const symbols: Record<string, string> = {PLN: 'zł', EUR: '€', USD: '$', UAH: '₴'};

export const getCurrencySymbol = (currency: string = DEFAULT_CURRENCY) => symbols[currency] ?? currency;

export const formatMoney = (value: number | string, currency: string = DEFAULT_CURRENCY) => `${priceFormatter(value)} ${getCurrencySymbol(currency)}`;
